import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Segment } from '../common/Layout'
import { TextField, InputMaskField } from '@foodsby/nutrient'
import ModalPopup from '../common/ModalPopup'
import { confirmation, length, required } from 'redux-form-validators'
import { Submitting } from '../common/Submitting'
import LocationSearchContainer from '../location-search/LocationSearchContainer'
import { updatePersonalInfoStart } from '../../redux/modules/profile'
import LinkPopup from '../common/LinkPopup'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { formatTenDigitPhoneNumber } from '../../util/formatUtils'
import { noSpacesAllowed } from '../../util/validators'
import SaveAndCancelButtons from './SaveAndCancelButtons'

export const PersonalInformationForm = ({
  changePersonalInfoEditingMode,
  handleSubmit,
  firstName,
  lastName,
  phone,
  submitting
}) => (
  <form onSubmit={handleSubmit}>
    <div className="row">
      <div className="col-xs-12">
        <div className="row middle-xs">
          <div className="col-xs-12 col-md-6">
            <Field
              name="firstName"
              type="text"
              maxLength="35"
              component={TextField}
              label="First Name *"
              validate={[
                noSpacesAllowed,
                required({ msg: `First Name is required` })
              ]}
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <Field
              name="lastName"
              type="text"
              component={TextField}
              label="Last Name *"
              maxLength="35"
              validate={[
                noSpacesAllowed,
                required({ msg: `Last Name is required` })
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Field
              name="phone"
              type="tel"
              component={InputMaskField}
              mask="(999) 999-9999"
              label="Phone Number *"
              normalize={val => val.replace(/\D/g, '')}
              validate={[
                noSpacesAllowed,
                required({ msg: `Phone Number is required` }),
                length({
                  is: 10,
                  msg: { wrongLength: `Phone Number must be 10 digits` }
                })
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  </form>
)

export const ReduxPersonalInformationForm = reduxForm({
  form: 'personalInfo',
  onSubmit: updatePersonalInfoStart
})(PersonalInformationForm)

const SuccessMessage = () => (
  <span className="success col-xs-12">
    <i className="icon-check-circle success" />
    Your Password has been successfully changed.
  </span>
)

const FailureMessage = () => (
  <span className="error col-xs-12">
    Sorry your password was not changed, please verify the information entered
    and try again.
  </span>
)

export const MiniChangePasswordForm = ({
  changePasswordEditingMode,
  handleSubmit,
  submitting,
  failure,
  pristine,
  invalid
}) => (
  <form onSubmit={handleSubmit}>
    <div className="col-xs-12 _lr-hide">
      <Field
        id="oldPassword"
        name="oldPassword"
        type="password"
        component={TextField}
        label="Current Password *"
        validate={[
          required({ msg: `Current Password is required` }),
          length({
            minimum: 6,
            msg: 'Current Password is too short'
          })
        ]}
      />
    </div>
    <div className="col-xs-12 _lr-hide">
      <Field
        id="password"
        name="password"
        type="password"
        component={TextField}
        label="New Password *"
        validate={[
          noSpacesAllowed,
          required({ msg: `New Password is required` }),
          length({ minimum: 8, msg: 'New Password is too short' })
        ]}
      />
    </div>
    <div className="col-xs-12 _lr-hide">
      <Field
        id="confirmPassword"
        name="confirmPassword"
        type="password"
        component={TextField}
        label="Confirm Password *"
        validate={[
          noSpacesAllowed,
          confirmation({
            field: 'password',
            fieldLabel: 'New Password',
            msg: 'Password does not match New Password'
          })
        ]}
      />
    </div>
    {failure ? <FailureMessage /> : null}
    <div className="row middle-xs">
      <div className="col-xs center-xs">
        <button
          type="button"
          className="link cancel"
          onClick={() => changePasswordEditingMode(false)}
        >
          Cancel
        </button>
      </div>
      <div className="col-xs center-xs">
        {submitting ? (
          <Submitting />
        ) : (
          <button type="submit" disabled={invalid || pristine}>
            Save Changes
          </button>
        )}
      </div>
    </div>
  </form>
)

export const ReduxMiniChangePasswordForm = reduxForm({
  form: 'changePassword'
})(MiniChangePasswordForm)

export const ProfileNamePanel = ({
  firstName,
  lastName,
  phone,
  changePersonalInfoEditingMode,
  isCurrentUserLoading
}) => (
  <div className="row">
    <div className="col-xs-12">
      {isCurrentUserLoading ? (
        <SimpleSpinner />
      ) : (
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <label htmlFor="firstName">First Name</label>
            <p className="segment-text">
              {firstName == null ? 'No First Name Provided' : firstName}
            </p>
          </div>
          <div className="col-xs-12 col-md-6">
            <label htmlFor="lastName">Last Name</label>
            <p className="segment-text">
              {lastName == null ? 'No Last Name Provided' : lastName}
            </p>
          </div>
          <div className="col-xs-12 col-md-6">
            <label htmlFor="phone">Phone Number</label>
            <p className="segment-text">
              {formatTenDigitPhoneNumber(phone) == null
                ? 'No Phone Number Provided'
                : formatTenDigitPhoneNumber(phone)}
            </p>
          </div>
        </div>
      )}
    </div>
  </div>
)

export const ChangePasswordPanel = ({
  isChangingPassword,
  changePasswordEditingMode,
  changePasswordStart,
  success,
  failure,
  email
}) => (
  <div className="row">
    <div className="col-xs-12 col-md-6">
      <label htmlFor="email">Email Address</label>
      <p className="segment-text" style={{ marginBottom: '0', height: '35px' }}>
        {email}
      </p>
      <button
        style={{
          marginBottom: '20px',
          fontSize: '16px',
          paddingLeft: '11px'
        }}
        className="link secondary change-password"
        onClick={() => changePasswordEditingMode(true)}
      >
        Change Password
      </button>
      {isChangingPassword ? (
        <ModalPopup showCancel={false}>
          <ReduxMiniChangePasswordForm
            onSubmit={changePasswordStart}
            changePasswordEditingMode={changePasswordEditingMode}
            failure={failure}
          />
        </ModalPopup>
      ) : null}
      {success ? <SuccessMessage /> : null}
    </div>
  </div>
)

export class ChangeLocationPanel extends Component {
  constructor(props) {
    super(props)
    this.state = { showModal: false }
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  showModal() {
    this.setState({ showModal: true })
  }

  hideModal() {
    this.setState({ showModal: false })
  }

  render() {
    const {
      location: { deliveryLocationName, street }
    } = this.props
    return (
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <label htmlFor="buildingName">Building Name</label>
          <p className="segment-text">{deliveryLocationName}</p>
        </div>
        <div className="col-xs-12 col-md-6">
          <label htmlFor="buildingAddress">Building Address</label>
          <p
            className="segment-text"
            style={{ marginBottom: '0px', height: '35px' }}
          >
            {street}
          </p>
          <LinkPopup
            style={{ fontSize: '16px', paddingLeft: '11px' }}
            linkText="Change Location"
          >
            <LocationSearchContainer />
          </LinkPopup>
        </div>
      </div>
    )
  }
}
export const EditButton = ({ changePersonalInfoEditingMode }) => (
  <div className="col-xs-6">
    <button
      style={{ float: 'right' }}
      className="button secondary change-name"
      onClick={() => changePersonalInfoEditingMode(true)}
    >
      Edit Profile
    </button>
  </div>
)

export const PersonalInformationPanel = ({
  profile: { firstName, lastName, phone, username },
  isEditingPersonalInfo,
  changePersonalInfoEditingMode,
  isChangingPassword,
  changePasswordEditingMode,
  changePasswordStart,
  updatePersonalInfoStart,
  location,
  submitting,
  success,
  changePasswordFailed,
  isCurrentUserLoading
}) => (
  <Segment>
    <div
      className="row"
      style={{
        borderBottom: '1px solid #d3d3d3',
        height: '60px',
        marginBottom: '20px'
      }}
    >
      <div className="col-xs-6">
        <h2 style={{ fontSize: '20px', marginTop: '10px' }}>
          Personal Information
        </h2>
      </div>
      {isEditingPersonalInfo ? (
        <SaveAndCancelButtons
          changePersonalInfoEditingMode={changePersonalInfoEditingMode}
          submitting={submitting}
          formName={'personalInfo'}
        />
      ) : (
        <EditButton
          changePersonalInfoEditingMode={changePersonalInfoEditingMode}
        />
      )}
    </div>

    {isEditingPersonalInfo ? (
      <ReduxPersonalInformationForm
        initialValues={{
          firstName,
          lastName,
          phone
        }}
        onSubmit={updatePersonalInfoStart}
        changePersonalInfoEditingMode={changePersonalInfoEditingMode}
        submitting={submitting}
      />
    ) : (
      <ProfileNamePanel
        firstName={firstName}
        lastName={lastName}
        phone={phone}
        changePersonalInfoEditingMode={changePersonalInfoEditingMode}
        isCurrentUserLoading={isCurrentUserLoading}
      />
    )}
    <ChangePasswordPanel
      email={username}
      isChangingPassword={isChangingPassword}
      changePasswordEditingMode={changePasswordEditingMode}
      changePasswordStart={changePasswordStart}
      submitting={submitting}
      success={success}
      failure={changePasswordFailed}
    />
    {location && <ChangeLocationPanel location={location} />}
  </Segment>
)

PersonalInformationPanel.defaultProps = {
  profile: {}
}

export default PersonalInformationPanel
